import React from 'react'

export const FooterNavLayout = ({ children }) => {
  return <nav>{children}</nav>
}
